/* eslint-disable no-restricted-syntax */
import { acceptDefaults, TAcceptDefaults, TAcceptFormats, TFormats } from './types'

export function filterAcceptFormats(acceptFormats: TFormats[]): Partial<TAcceptDefaults> {
  const filteredAccepts: Partial<TAcceptDefaults> = {}

  for (const format of acceptFormats) {
    for (const [mime, extensions] of Object.entries(acceptDefaults)) {
      if (extensions.includes(format)) {
        filteredAccepts[mime as TAcceptFormats] = extensions

        break
      }
    }
  }

  return filteredAccepts
}

export function formatFileSize(fileSizeInBytes: number): string {
  const units = ['B', 'KB', 'MB', 'GB', 'TB']

  let size = fileSizeInBytes

  let unitIndex = 0

  while (size > 1024 && unitIndex < units.length - 1) {
    size /= 1024

    // eslint-disable-next-line no-plusplus
    unitIndex++
  }

  return `${size.toFixed(0)} ${units[unitIndex]}`
}
